export default "__VITE_ASSET__CkEVtvZ9__"